import { gql } from "@apollo/client";
const SingleUploadMutation = gql`
  mutation SingleUploadMutation(
    $uploadId: BigInt!
    $projectName: String!
    $fileName: String!
  ) {
    singleUpload(
      input: {
        uploadId: $uploadId
        projectName: $projectName
        fileName: $fileName
      }
    ) {
      url
      urlPath
    }
  }
`;

const hash = "366f3bc41e416a49b6bd3ae0d04b0c682dcc7d82f43ed3a172e4b69180a1f11f";

export { SingleUploadMutation, hash };
